import config from '../../config';

/**
 * Base URL for marketplace-api's OWN endpoints — `/api/configuration`, `/api/account/*`,
 * `/api/oauth/*`. These are served by marketplace-api (not the legacy AWG data API, which uses the
 * absolute `apiRoot`/`coreRoot` config values).
 *
 * - Production: marketplace-api is same-origin, so this returns '' and callers use relative `/api/...`.
 * - Development (see config/index.dev.js):
 *     - `apiProxyTarget` set  -> '' (same-origin); src/setupProxy.js forwards /api to the local API.
 *     - else `apiBase` set    -> that origin (direct, cross-origin).
 *     - else                  -> the deployed marketplace-api for DEV_CUSTOMER over https.
 *
 * @returns {string} origin (no trailing slash) or '' for same-origin
 */
export function getMarketplaceApiBase() {
  if (process.env.NODE_ENV !== 'development') {
    return '';
  }
  if (config.apiProxyTarget) {
    return ''; // same-origin: the dev proxy forwards /api to the local marketplace-api
  }
  const base = config.apiBase || `https://${config.devEndpoint}`;
  return base.replace(/\/$/, '');
}

/**
 * Origin that marketplace-api pages (e.g. the OIDC popup handoff) will post messages FROM. Same-origin
 * in production; the API origin in dev when pointed at a different host.
 * @returns {string}
 */
export function getMarketplaceApiOrigin() {
  const base = getMarketplaceApiBase();
  return base ? new URL(base).origin : window.location.origin;
}
